import { ChecklistQuestionCategory, InfractionType, RolesType } from '@rapid-recovery-agency-inc/insightt-graphql';

export const InfractionTypeTabValue = {
  SHIFT_MOTION_IDLE_INACTIVITY: InfractionType.SHIFT_MOTION_IDLE_INACTIVITY,
  SHIFT_RDN_INACTIVITY: InfractionType.SHIFT_RDN_INACTIVITY,
  SHIFT_START_LATER: InfractionType.SHIFT_START_LATER,
  SHIFT_END_EARLY: InfractionType.SHIFT_END_EARLY,
  SHIFT_BREAK_OVER_TIME: InfractionType.SHIFT_BREAK_OVER_TIME,
} as const;

export const InfractionChecklistTabValues = {
  shift_motion_idle_inactivity: 'motion_tracker',
  shift_rdn_inactivity: 'activity_tracker',
  shift_start_later: 'late_start',
  shift_end_early: 'early_end',
  shift_break_over_time: 'break_overtime',
} as const;

export const ChecklistTabValue = {
  ...ChecklistQuestionCategory,
  ...InfractionTypeTabValue,
} as const;

export type ChecklistTabValueEnum = (typeof ChecklistTabValue)[keyof typeof ChecklistTabValue];

export interface ChecklistResponseType {
  id: number;
  question?: string;
  index?: number;
  roleId: number | undefined;
  photo?: number;
  input?: number;
  file?: number;
}

export interface ChecklistCreateDataType {
  selectedRole: RolesType[];
  selectedCategory: ChecklistTabValueEnum[];
  checklistItems: ChecklistResponseType[];
}
